import Button from 'src/components/Button/Button';
import style from './SuccessfullyLinked.module.scss';
import { ReactComponent as WalletLinkIcon } from 'src/assets/icons/wallet-link.svg';

export const SuccessfullyLinked = ({ onClose }) => {
    return (
        <div className={style.successfullyLinked}>
            <div className={style.illustration}>
                <img src="/assets/images/syncronized-illustration.png" alt="Link wallet illustration" />
            </div>
            <div className={style.content}>
                <WalletLinkIcon />
                <strong>Your wallet has been successfully linked!</strong>
                <p>
                    You can now return to the application and enjoy the benefits associated with the actions performed
                    using this wallet.
                </p>
                <Button onClick={onClose}>Understood</Button>
            </div>
        </div>
    );
};
